export default "__VITE_ASSET__COou4PT7__"